import React from 'react';
import { withTranslation } from 'react-i18next';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const SIGN_UP_VERIFICATION_NOTICE_KEY = 'app/signUpVerificationNotice';

const getVerificationErrorMessage = (error, t) =>
  error?.message || t('emailVerification.error_fallback');

const getVerificationNoticeMessage = (notice, t) => {
  if (!notice) {
    return '';
  }

  return notice.includes('.') ? t(notice) : notice;
};

const needsEmailVerification = authUser =>
  authUser &&
  !authUser.emailVerified &&
  authUser.providerData
    .map(provider => provider.providerId)
    .includes('password');

const withEmailVerification = Component => {
  class WithEmailVerification extends React.Component {
    constructor(props) {
      super(props);

      this.state = { isSent: false, notice: '', error: '' };
    }

    componentDidMount() {
      const notice = sessionStorage.getItem(SIGN_UP_VERIFICATION_NOTICE_KEY) || '';
      if (notice) {
        sessionStorage.removeItem(SIGN_UP_VERIFICATION_NOTICE_KEY);
        this.setState({ notice: getVerificationNoticeMessage(notice, this.props.t) });
      }
    }

    onSendEmailVerification = () => {
      this.props.firebase
        .doSendEmailVerification()
        .then(() => this.setState({ isSent: true, error: '', notice: '' }))
        .catch(error => this.setState({
          error: getVerificationErrorMessage(error, this.props.t),
          isSent: false,
        }));
    };

    render() {
      return (
        <AuthUserContext.Consumer>
          {authUser =>
            needsEmailVerification(authUser) ? (
              <main className='auth-main'>
                <div className='auth-left'>
                  <div className='auth-card'>
                    <h1>{this.props.t('emailVerification.title')}</h1>
                    <div className='auth-form'>
                      {this.state.notice ? (
                        <p className='auth-error'>{this.state.notice}</p>
                      ) : null}
                      {this.state.error ? (
                        <p className='auth-error'>{this.state.error}</p>
                      ) : null}
                      {this.state.isSent ? (
                        <p>
                          {this.props.t('emailVerification.sent_message')}
                        </p>
                      ) : (
                        <p>
                          {this.props.t('emailVerification.pending_message')}
                        </p>
                      )}
                      <button
                        type='button'
                        onClick={this.onSendEmailVerification}
                        disabled={this.state.isSent}
                      >
                        {this.props.t('emailVerification.send_button')}
                      </button>
                    </div>
                  </div>
                </div>
                <div className='auth-right'>
                  <img
                    src='https://picsum.photos/1200/1200'
                    alt={this.props.t('emailVerification.image_alt')}
                    loading='lazy'
                    sizes='(max-width: 600px) 200px, (max-width: 1200px) 400px, 800px'
                  />
                </div>
              </main>
            ) : (
              <Component {...this.props} />
            )
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return withFirebase(withTranslation()(WithEmailVerification));
};

export default withEmailVerification;
